export default __webpack_public_path__ + "static/media/SELLOS_03.775e8333.png";